module.exports = {"faq":{"title":["Frequentrly asked questions","Oftest stillede spørgsmål"],"need_help":["Need help? Here you can find the most common Questions and Answers.","Brug for hjælp? Her kan du finde svar på de spørgsmål vi oftest får."],"keywords":["Search using Keywords","Søg på dit spørgsmål"],"no_questions":["Sorry, no match found","Vi kunne desværre ikke finde nogle spørgsmål eller svar"]}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/faq/faq.locale.json
// module id = 682
// module chunks = 0